<template>
  <div class="pages privacy">
    <div class="container">
      <h3><a id="_0"></a>“熊猫绘画”隐私政策</h3>
      <p>
        <strong
          >更新日期：2024年7月10日<br />
          生效日期：2024年7月10日</strong
        >
      </p>
      <p>
        杭州摸鲸科技有限公司（简称“我们”）作为熊猫绘画的运营者，我们非常重视保护您的隐私和个人信息，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们希望通过本《隐私政策》向您清晰地介绍您在使用我们的产品与/或服务时，我们如何处理您的个人信息，以及我们为您提供的管理、保护这些信息的方式。<br />
        <strong
          >【特别提示】在使用熊猫绘画之前，请务必仔细阅读本政策，为实现您选择使用的功能、服务，或为遵守法律法规的要求，我们会处理相关信息。除实现熊猫绘画基本功能、服务所需的信息，和根据法律法规要求所必需的信息之外，您可以拒绝我们处理其他信息，但这可能导致我们无法提供对应功能、服务。我们将在隐私政策中逐项说明相关情况，有关您个人信息权益的重要条款已用加粗形式提示，请特别关注。</strong
        ><br />
        除本政策外，在特定场景下，我们将以及时告知的方式（包括但不限于更新本政策、页面提示、弹窗、站内信、）另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理<br />
        <strong>本政策将帮助您了解以下内容</strong><br />
        <strong
          >1我们如何收集和使用个人信息<br />
          2我们如何存储个人信息<br />
          3数据使用过程中涉及的合作方以及转移、公开个人信息<br />
          4我们如何保护个人信息安全<br />
          5您对个人信息享有的控制权<br />
          6未成年人保护相关功能<br />
          7适用范围<br />
          8其他<br />
          9如何联系我们</strong
        >
      </p>
      <p>
        <strong>1我们如何收集和使用个人信息</strong><br />
        <strong>1.1 帐号服务</strong><br />
        <strong>1.1.1 注册、登录</strong><br />
        当您注册、登录熊猫绘画以及使用相关服务时，为了帮您顺利完成注册/登录流程，您需要向我们提供您的<strong>手机号码</strong>、手机登录密码信息。收集手机号码是履行国家法律法规关于网络实名制（<strong>真实身份信息认证</strong>）要求的必要信息，如果您拒绝提供手机号码用于注册、登录，我们可能无法为您提供信息发布（包括发图文、评论等）功能，但不影响您正常浏览内容。<br />
        您可以通过手机号码创建帐号，可以完善相关的网络身份识别信息（头像、昵称、密码）。<br />
        一键登录：基于我们与通信运营商的合作，当您使用“一键登录”功能时，经过您的同意，运营商会将您的手机号码发送给我们，便于我们为您提供免于密码或动态验证码核验的快捷登录服务。如果你不希望使用“一键登录”功能，可以通过其他方式注册、登录熊猫绘画。<br />
        您还可以使用第三方（微信）帐号注册、登录熊猫绘画，但需要授权我们获取您在第三方平台的信息（头像、昵称以及您授权的其他信息），用于生成与该第三方帐号绑定的熊猫绘画帐号，使您可以直接注册、登录并使用熊猫绘画和相关服务。<br />
        如果您忘记了您熊猫绘画的登录方式，可以使用找回密码功能。为保障您帐号的安全，我们需要您填写相关信息以进行验证，必要时可能通过<strong>真实身份信息</strong>验证等方式验证您的身份。<br />
        <strong>1.1.2 账号资料维护</strong><br />
        为便于您在熊猫绘画内对个人资料进行查看与维护，您可自主选择填写您的性别、昵称、头像、手机号码。如您未填写，不影响您使用我们产品或服务的基本功能。<br />
        您在上传/更换头像时，我们会请求您的<strong>相机、相册</strong>权限，并在经您授权后收集您上传/更换的图片信息。<br />
        <strong>1.1.3 实名认证</strong><br />
        为满足相关法律规定及监管要求、确保用户身份真实性、实现反欺诈等风险控制、保障系统和服务安全，在您开通集市、申请提现或使用其他需实名认证的功能或服务时，需要您提供<strong>真实身份信息</strong>（<strong>真实姓名、身份证件号码或人脸信息，根据实际情况可能有所不同</strong>）以完成实名认证。<br />
        在实名认证的过程中，需要由提供认证服务的第三方认证机构核验您的<strong>真实身份信息</strong>。这些信息仅供完成实名认证使用，或其他法律法规所规定的用途，不会用作其他目的。您可以拒绝提供此认证，将无法使用必须实名认证才可使用的功能或相关服务。但不影响您使用其他功能与服务。<br />
        基于法律法规的相关要求，您的<strong>实名认证信息</strong>还可能被我们用于青少年/儿童保护、防沉迷相关的产品或服务。<br />
        <strong>1.1.4 帐号公开信息</strong><br />
        我们会在您注册熊猫绘画时为您的帐号生成熊猫绘画ID号，ID号是您的帐号的公开识别符号。<br />
        您的<strong>画题数、关注数、关注列表、粉丝数、粉丝列表</strong>、您公开发布的作品、您推荐的作品，将会在您帐号的个人主页中公开展示。通过【我的】-【设置中心】-【隐私设置】，您可以选择不公开展示您的关注列表、粉丝列表和画题。<br />
        我们发布违规处罚公告时，会公布违规帐号的昵称ID以及违规原因等信息。<br />
        <strong>1.1.5熊猫绘画统一账号和关联产品</strong><br />
        熊猫绘画各关联产品均使用统一的熊猫绘画帐号服务，包括不限于熊猫绘画、熊猫绘画PRO、熊猫绘画PC版以及熊猫绘画官方网站。
        <strong
          >您可以使用熊猫绘画帐号便捷地登录、使用熊猫绘画关联产品，和对应产品的服务或功能。如您在任一款产品中对账号信息</strong
        >（<strong>包括账号密码、手机号码等</strong>）<strong>进行修改，该修改将会自动同步至您的统一账号</strong>。您理解并同意，如您在任一款产品中实施账户注销，将可能会影响您使用其他产品。<br />
        <strong>1.2 内容浏览和搜索</strong><br />
        当您使用熊猫绘画浏览内容时，我们会记录您的使用情况。如果您没有登录帐号，我们会通过设备对应的信息来记录您的浏览信息。如果您已登录帐号，我们会通过您的熊猫绘画帐号记录您的【<strong>浏览、点击、分享、关注、收藏、反馈、发布、点赞（喜欢）、评论、访问日期、时间、时长等</strong>】。<br />
        当您使用搜索功能时，我们会自动收集您的搜索关键字信息，为了提供高效的搜索服务，这部分信息会暂时存储在您的本地设备端，并向您展示搜索历史记录<br />
        <strong>1.3 信息发布</strong><br />
        您在绘画或发布图文作品时、我们会根据您使用的功能类型分别请求您授权<strong>相机、相册</strong>权限，用于拍照和访问相册。如您拒绝授权，将无法使用发布图片、根据图片创建画布、临摹参考和导入图片功能，但不影响您使用熊猫绘画的其他功能。您可以在客户端或设备的设置功能中选择关闭部分或全部权限。在不同设备中，上述权限的开启和关闭方式可能有所不同，具体请参考设备及系统开发方的说明或指引，调用权限的具体情况请见<a
          href="https://static.pandapaint.net/pagesart/agreement/#/permissions"
          target="_blank"
          >《设备权限清单》</a
        >。<br />
        您在使用IM语音聊天时，我们会申请您授权<strong>麦克风</strong>权限，用于发送语音聊天内容，如果您拒绝，将无法使用语音聊天功能，但不影响您使用熊猫绘画的其他功能。<br />
        <strong>1.4绘画工具</strong><br />
        您在使用熊猫绘画绘画工具时，我们会申请您授权<strong>存储</strong>权限，用以记录您的绘画数据，如果您拒绝，将无法使用绘画功能。<br />
        <strong>1.5 下单与支付</strong><br />
        当您在熊猫绘画中购买商品或服务时（包含开通/续费VIP），为便于协助您顺利完成交易、查询订单信息，以及向您提供客户服务和保障您的交易安全，我们需要根据商品或服务类型收集如下部分或全部的个人信息：包括<strong>订单编号、交易金额、下单时间、订单状态、支付方式、支付账号、支付状态</strong>。<br />
        <strong>1.6 运营与安全运行</strong><br />
        我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护相关产品或服务的正常稳定运行，保护您或其他用户或公众的安全及合法利益，我们会收集如下必要信息：<br />
        1.6.1为了保障软件与服务的安全运行、运营的质量及效率，我们会在应用运行时和后台状态下收集您的<strong>硬件型号、设备分辨率、操作系统版本号、设备标识符</strong>（如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID）、网络设备硬件地址（MAC地址）、硬件序列号、IP
        地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息、设备应用安装列表、任务列表等数据。<br />
        1.6.2为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。<br />
        1.6.3我们可能使用您的帐号信息、设备信息、服务日志信息，以及我们的关联方、合作方获得您授权或依法可以提供给我们的信息，用于判断帐号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。<br />
        <strong>1.7 广告（含个性化广告）</strong><br />
        我们可能使用您的设备标识符（如IMEI、IDFA、OAID等），广告数据（如曝光、点击、转化数据等），设备信息（如设备型号、系统语言、屏幕高宽、屏幕方向等），应用及使用数据（如应用包名、操作日志等），连接的<strong>WIFI</strong>，粗略<strong>地理位置</strong>信息，在本产品中向您提供您可能感兴趣的广告，评估、改善我们的广告投放和其他促销及推广活动、商业分析的效果，以实现广告投放、优化与提升广告有效触达率。<br />
        当您使用创新广告交互功能（如摇动、扭动、扭转设备）时，我们会调用设备的陀螺仪、加速度、重力传感器以识别判断您的设备状态。单独的设备传感器数据不涉及任何个人位置信息且无法与其他信息结合用于识别特定自然人的身份。<br />
        <strong
          >请您放心，个性化广告推荐算法并不会识别您的真实身份，仅是基于推测的特征提供对您更有价值的广告信息、节约您的交易成本。</strong
        ><br />
        若您不想接受个性化广告服务，您可以在我们的产品务的相关功能设置页面开启/关闭个性化广告。个性化广告设置路径为：“【我的】-【设置中心】-【个性化广告管理】”。若您选择关闭，您看到的广告数量不会减少，但本产品将不再向您展示个性化广告，您看到的广告将可能与您的偏好相关度降低。<br />
        <strong>1.8Cookie等同类技术的使用</strong><br />
        Cookie
        和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用熊猫绘画及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie
        或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie
        用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie
        和同类技术主要为了实现以下功能或服务：<br />
        保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的Cookie
        或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br />
        帮助您获得更轻松的访问体验：使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。<br />
        在熊猫绘画的分享页中，我们可能会使用Cookie对浏览活动进行记录，用于排查崩溃、延迟的相关异常情况以及探索更好的服务方式。<br />
        <strong>1.9 服务内容的变更</strong><br />
        请您了解，随着我们业务的发展，可能会调整熊猫绘画提供的产品或服务。如调整变化后的产品或服务所处理个人信息的目的、方式和范围发生变化的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意。
      </p>
      <p>
        <strong>1.10依法豁免征得同意处理个人信息</strong><br />
        请您理解，在下列情形中，根据法律法规，我们处理您的个人信息无需征得您的授权同意。<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <p>
        <strong>2我们如何存储个人信息</strong><br />
        <strong>2.1信息存储的地点</strong><br />
        我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循国家相关规定，征求您的同意。
      </p>
      <p>
        <strong>3数据使用过程中涉及的合作方以及转移、公开个人信息</strong><br />
        <strong>3.1数据使用过程中涉及的合作方</strong><br />
        <strong>3.1.1基本原则</strong><br />
        我们与合作方合作过程中，将遵守以下原则：<br />
        a) 合法原则：涉及数据处理活动的，应当遵守合法原则。<br />
        b)
        正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。<br />
        c) 安全审慎原则：
        我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
      </p>
      <p>
        <strong>3.1.2第三方SDK清单</strong><br />
        为保障熊猫绘画APP相关功能的实现与应用安全稳定的运行，我们会接入由第三方提供的软件工具开发包（SDK）实现相关目的。
      </p>
      <table>
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>SDK所属公司</th>
            <th>用途</th>
            <th>读取的信息或需要您打开的权限</th>
            <th>第三方隐私政策链接</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>MobTech ShareSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>为用户提供社交分享、第三方登录社交分享、第三方登录服务</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a href="https://www.mob.com/about/policy1" target="_blank"
                >《Mob隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>MobTech SMSSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>短信验证功能</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a href="https://www.mob.com/about/policy1" target="_blank"
                >《Mob隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>MobTech MobPushSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>为您提供 消息推送服务</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a href="https://www.mob.com/about/policy1" target="_blank"
                >《Mob隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>talkingdata</td>
            <td>北京腾云天下科技有限公司</td>
            <td>匿名统计分析</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn"
                target="_blank"
                >《talkingdata隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>小米推送</td>
            <td>小米科技有限公司</td>
            <td>推送消息</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://dev.mi.com/console/doc/detail?pId=1822/"
                target="_blank"
                >《小米推送隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>OPPO 推送</td>
            <td>广东欢太科技有限公司</td>
            <td>推送消息</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a
                href="https://open.oppomobile.com/wiki/doc#id=10288"
                target="_blank"
                >《OPPO开放平台隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>vivo 推送</td>
            <td>广东天宸网络科技有限公司及将来受让运营vivo开放平台的公司</td>
            <td>推送消息</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a
                href="https://dev.vivo.com.cn/documentCenter/doc/366"
                target="_blank"
                >《vivo开放平台服务协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>华为推送</td>
            <td>华为软件技术有限公司</td>
            <td>推送消息</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a
                href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021/"
                target="_blank"
                >《华为隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>魅族推送</td>
            <td>
              珠海市魅族通讯设备有限公司及其关联方（简称魅族）、与魅族建立合作的合作方公司
            </td>
            <td>推送消息</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a href="https://www.meizu.com/legal.html" target="_blank"
                >《魅族隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>支付宝支付</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>支付宝付款</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://opendocs.alipay.com/common/02kiq3"
                target="_blank"
                >《支付宝隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>微信登录支付</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>微信账号登录；APP内容分享到微信好友、朋友圈；微信支付</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy/"
                target="_blank"
                >《微信隐私保护指引》</a
              >
            </td>
          </tr>
          <tr>
            <td>QQ</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>QQ钱包支付；APP内容分享到QQ好友、QQ空间</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://privacy.qq.com/policy/tencent-privacypolicy/"
                target="_blank"
                >《QQ隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>微博开放平台</td>
            <td>北京微梦创科网络技术有限公司</td>
            <td>APP内容分享到微博</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a href="https://m.weibo.cn/c/privacy" target="_blank"
                >《微博个人信息保护政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里云存储(OSS)</td>
            <td>阿里云计算有限公司</td>
            <td>保存作品图片、保存用户头像等数据</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201710161525_98396.html"
                target="_blank"
                >《阿里云法律声明及隐私权政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯云慧眼人脸核身SDK</td>
            <td>腾讯云计算（北京）有限责任公司</td>
            <td>用于实人实名认证</td>
            <td>网络权限、相机使用权限</td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2"
                target="_blank"
                >《腾讯云慧眼人脸核身SDK隐私保护指引》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯云通信</td>
            <td>腾讯云计算（北京）有限责任公司</td>
            <td>即时通信</td>
            <td>网络权限、读写储存权限、麦克风、相机、获取手机信息权限</td>
            <td>
              <a
                href="https://cloud.tencent.com/document/product/269/58094"
                target="_blank"
                >《IM SDK 隐私保护指引》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯优量汇</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>推送程序化广告</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a
                href="https://e.qq.com/dev/help_detail.html?cid=2005&amp;pid=5983"
                target="_blank"
                >《优量汇 SDK个人信息保护规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>BeiZi SDK</td>
            <td>上海倍孜网络技术有限公司</td>
            <td>推送程序化广告</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy"
                target="_blank"
                >《BeiZi隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>联通一键登录</td>
            <td>中国联合网络通信有限公司</td>
            <td>一键登录</td>
            <td>网络权限、获取手机信息权限</td>
            <td>
              <a
                href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html"
                target="_blank"
                >《联通统一认证服务条款》</a
              >
            </td>
          </tr>
          <tr>
            <td>移动一键登录</td>
            <td>中移互联网有限公司</td>
            <td>一键登录</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://wap.cmpassport.com/resources/html/contract.html"
                target="_blank"
                >《移动统一认证服务条款》</a
              >
            </td>
          </tr>
          <tr>
            <td>电信一键登录</td>
            <td>世纪龙信息网络有限责任公司</td>
            <td>一键登录</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>
              <a
                href="https://e.189.cn/sdk/agreement/content.do?type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl="
                target="_blank"
                >《天翼账号服务协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>数美SDK</td>
            <td>北京数美时代科技有限公司</td>
            <td>账户与设备风险保护</td>
            <td>
              设备信息、网络信息、读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>
              <a
                href="https://www.ishumei.com/legal/cn/privacy.html"
                target="_blank"
                >《数美科技隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>Bugly SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>本SDK运行时对发生的的故障问题进行排查、分析、解决</td>
            <td>
              设备信息、网络信息、读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                target="_blank"
                >《Bugly SDK个人信息保护规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>网易七鱼SDK</td>
            <td>杭州网易智企科技有限公司</td>
            <td>获取OAID</td>
            <td>
              设备信息、网络信息、读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>
              <a
                href="https://support.dun.163.com/documents/413846598587424768?docId=507376333387018240"
                target="_blank"
                >《网易易盾隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>百度网盘开放云盘</td>
            <td>北京度友科技有限公司</td>
            <td>登录百度账号，备份草稿/笔刷/色卡到云盘</td>
            <td>
              设备信息、网络信息、读取存储权限、设备序列号、设备传感器信息
            </td>
            <td>
              <a
                href="https://pan.baidu.com/union/protocol/hl56pr0w6"
                target="_blank"
                >《百度网盘开放平台用户隐私协议》</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <strong>3.1.3 委托处理</strong><br />
        <strong
          >对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。</strong
        ><br />
        <strong>3.1.4共同处理</strong><br />
        <strong
          >对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。</strong
        ><br />
        <strong>3.1.4.1实现广告相关的信息共享</strong><br />
        为实现程序化广告推送，我们可能会与广告合作伙伴（包括广告主和其他广告服务提供商）共享去标识化或匿名化处理后的信息，以帮助其在不识别您<strong>个人身份</strong>的前提下提升广告的有效触达率。未经您授权，我们不会将您的个人身份信息（即可以识别您身份的信息，例如<strong>姓名</strong>或<strong>手机号码</strong>）与广告合作伙伴共享。<br />
        <strong>3.1.5合作方的范围</strong><br />
        若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。<br />
        <strong>3.2合作的场景</strong><br />
        <strong>3.2.1活动参与</strong><br />
        当您选择参加我们举办的营销活动时，经过您的同意，我们与合作方可能需要使用您的<strong>姓名、通信地址、联系方式、银行账号</strong>等信息，以便合作方向您兑现活动奖励。当您参与我们和关联方共同举办的营销活动时，可能会在多个参与活动的移动应用程序（简称“活动平台”）之间同步您参与活动的帐号（含标识符）、参与成绩、进度、收益等信息，以保障您在活动中获得完整的服务体验。<br />
        <strong>3.2.2支付服务</strong><br />
        支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要收集您的<strong>姓名、身份证号、银行卡类型及卡号、有效期及手机号码</strong>。身份证号和银行卡相关信息是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。<br />
        <strong>3.3 实现安全与统计分析</strong><br />
        a)
        保障使用安全：我们非常重视产品和服务的安全性，为保障熊猫绘画用户的正当合法权益免受不法侵害，我们的合作方可能会使用必要的<strong>设备、帐号及日志信息</strong>。<br />
        b）分析产品情况：为分析熊猫绘画的产品和服务的稳定性，提供分析服务的合作方可能需要使用服务情况（崩溃、闪退记录）、设备标识信息、应用总体安装使用情况等信息。<br />
        c)
        学术科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与合作的科研院所、高校等机构使用去标识化或匿名化的数据。<br />
        <strong>3.4 运营主体变更</strong><br />
        随着业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。<br />
        <strong>3.5停止运营</strong><br />
        如果我们停止运营产品或服务，将及时停止继续收集您的个人信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的个人信息进行删除或匿名化处理。<br />
        <strong>3.6 依法豁免征得您的授权同意的情形</strong><br />
        请您理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开您的个人信息无需征得您的授权同意：<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <p>
        <strong>4我们如何保护个人信息安全</strong><br />
        4.1<strong>我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏</strong>。<br />
        4.2我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br />
        4.3我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人
        信息，并适时对数据和技术进行安全审计。<br />
        4.4尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。<br />
        4.5我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br />
        4.6我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于熊猫绘画软件及相关服务。一旦您离开熊猫绘画及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在熊猫绘画软件及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于熊猫绘画的链接或引导。
      </p>
      <p>
        <strong>5您的权利</strong><br />
        我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使您有能力保障您的隐私和安全。<br />
        <strong>5.1访问、更正、删除您的个人信息</strong><br />
        您可以通过以下方式管理您的信息：<br />
        当您完成熊猫绘画的账号注册、登录并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给熊猫绘画软件及相关服务的个人信息（包括删除您已经发布的图文、评论、视频，修改昵称、头像等）。<br />
        一般情况下，您可以直接删除您发布的内容，或是在客户端应用程序中点击右下方【我的】-【设置】-【个人资料】，点击编辑资料后随时浏览、修改、删除自己提交的信息，但出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的某些初始注册信息（如实名认证后信息）；如您确有必要修改该类信息，请您通过在客户端应用程序中点击右下方【我的】进入个人中心，点击【设置】-【联系客服】联系我们，公司将尽快审核所涉问题，并由专人验证您的用户身份后及时予以回复。<br />
        <strong>5.2管理、撤回授权您的信息</strong><br />
        您可以在设备的设置功能中开启或关闭<strong>摄像头、麦克风、相册、存储</strong>等权限，改变授权范围或撤回您的授权<br />
        请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响公司此前基于您的授权而开展的个人信息处理。
      </p>
      <p>
        <strong>5.3注销您的账号</strong><br />
        您可以在客户端应用程序中点击下方的【我的】进入个人中心，点击【设置】-【账号与安全】-【注销账号】注销您的账号。在您注销账号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将删除有关您账号的一切信息或对相关信息进行匿名化处理，但法律法规另有规定的除外。<br />
        <strong>5.4投诉举报</strong><br />
        您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过以下手段与我们联系，我们核查后会在30日内反馈您的投诉与举报：<br />
        5.4.1如果是相关作品侵害了您的个人信息权利，请在熊猫绘画移动客户端对应的作品页面内点击右上角图标再点击【举报】进行反馈<br />
        5.4.2如果是相关作品下的评论侵害了您的个人信息权利，请点击要举报的评论，再点击【举报】进行反馈<br />
        5.4.3如果在以上情况之外，请通过点击【我的】进入个人中心，点击【设置】-【联系客服】与我们联系。<br />
        5.4.4我们核查后会在30日内反馈您的投诉与举报。<br />
        <strong>5.5访问隐私政策</strong><br />
        您可以在注册页面，或者在登录个人账号【我的】—【设置】—【关于】—【隐私政策】查看本隐私政策的全部内容。
      </p>
      <p>
        <strong>6未成年人保护相关功能</strong><br />
        <strong>6.1青少年模式</strong><br />
        我们会在您首次进入熊猫绘画时，提醒您是否打开青少年模式。<br />
        您也可以在【我的】-【青少年模式】中主动打开青少年模式。<br />
        青少年模式开启后，该帐号只能在特定时段和时长内使用熊猫绘画。超过特定时长或不在特定时段时，需要输入正确的密码才可继续使用。<br />
        <strong>6.2功能限制、时间限制</strong><br />
        开启青少年模式后，将无法在集市购买商品；无法使用信息聊天功能；无法赠送收费礼物；限制使用时长，每天可累计使用60分钟；每日晚22：00至次日早6：00无法使用熊猫绘画。
      </p>
      <p>
        <strong>7适用范围</strong><br />
        本隐私权政策适用于由杭州摸鲸科技有限公司及其关联方提供的所有服务，包括熊猫绘画客户端、网站等，不适用于有单独的隐私权政策且未纳入本隐私权政策的第三方产品或服务。<br />
        本隐私权政策不适用于：为熊猫绘画服务进行广告宣传的其他第三方。您使用这些第三方服务（包括您向这些第三方提供的任何个人信息），将受这些第三方的服务条款及隐私政策约束（而非本隐私政策），具体规定请您仔细阅读第三方的条款。请您妥善保护自己的个人信息，仅在必要的情况下向第三方提供。<br />
        本隐私政策中所述的熊猫绘画及相关服务有可能会根据您所使用的手机型号、系统版本、软件应用程序版本等因素而有所不同。最终的产品和服务以您所使用的熊猫绘画软件及相关服务为准。<br />
        如对本隐私政策内容有任何疑问、意见或建议，您可通过登录熊猫绘画客户端内的【我的】-【设置中心】-【联系客服】页面与我们联系。
      </p>
      <p>
        <strong>8其他</strong><br />
        本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。<br />
        《隐私政策》是我们统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于熊猫绘画用户。
      </p>
      <p>
        <strong>9如何联系我们</strong><br />
        杭州摸鲸科技有限公司将按照本政策保护您的信息。如您有关于网络信息安全的投诉和举报，或您对本政策、您的信息的相关事宜有任何问题、意见或建议，以及有关本政策或熊猫绘画隐私措施的问题请与我们的协调人联系（熊猫绘画客户端右下角【我的】-【设置】-【联系客服】）。<br />
        一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的十五天内予以回复。
      </p>
      <pre><code class="lang-language"> </code></pre>
    </div>
  </div>
</template>

<script>
export default {
  name: "Priacy",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.privacy {
  .container {
    line-height: 1.6em;
    font-size: 14px;
    h3 {
      font-size: 21px;
    }
    a {
      color: #1989fa;
      text-decoration: none;
    }
  }
  table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
      word-wrap: break-word;
    }
  }
}
</style>
